import {useEffect, useRef, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import ResetPassword from '../../app/pages/login/ResetPassword'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {Footer} from './components/Footer'
import Cookies from 'universal-cookie'
import {useNavigate} from 'react-router-dom'
import {default as Apiservices} from '../../../src/common/index'
import {ToastContainer, toast} from 'react-toastify'
import {ThingsProvider} from '../../app/modules/apps/masters/commonicons/GlobalContext'
import {ValidProvider} from '../../app/modules/apps/masters/commonicons/ValidateContext'
import serverCredintials from '../../common/serverCredintials'
import BackDrop from '../../app/modules/apps/timesheetentry/ComponentBackdrop'
import ChatBotIcon from '../../app/modules/chatbot/ChatBotIcon'

// const MasterLayout = () => {
export function MasterLayout(props: any) {
  const location = useLocation()
  const cookies = new Cookies()
  const navigate = useNavigate()
  const iframeRef: any = useRef(null)
  const [resetPassword, setresetPassword] = useState(false)
  const iframeSrc = serverCredintials.BuildURL.getTicketingWidgetURL()
  const [widgetToggle, setWidgetToggle] = useState(false)
  const [widgetShow, setWidgetShow] = useState(false)
  const [widgetShowPropKey, setWidgetShowPropKey] = useState()
  const [widgetRoute, setWidgetRoute] = useState('/')
  const [showBackDrop, setShowBackDrop] = useState(false)
  let business: any = localStorage.getItem('role_Name')
  const isLoggingOutRef = useRef(false)
  let numArray: any = business?.split(',')
  function removeAll() {
    let lRemove: any = [
      'token',
      'user_email',
      'org_list',
      'role_Name',
      'org_prefix',
      'org_id',
      'org_name',
      'tool_name',
      'ecdb_user_id',
      'userid',
      'Authorization',
      'NetSuiteToken',
      'enable_netsuite',
      'subsidary_name',
      'logged_in_id',
      'Announcement',
      'refresh_Token',
      'enable_quickbooks',
      'org_icon',
      'time_sheet_admin_screen_user_id',
      'MobileForceUpdateAccessbyEmail',
      'allowed_business_unit_id',
      'bu_list',
      'enable_unbilled',
      'invoice_access',
      'enable_email',
      'passwordExpiryDays',
      'passwordPopUpDays',
      'support',
      'is_pending_timesheet_submission',
      'is_timesheet_approval',
      'is_timesheet_rejection',
      'is_timesheet_reminder',
      'is_timesheet_submission',
    ]
    for (let each of lRemove) {
      localStorage.removeItem(each)
    }
  }
  useEffect(() => {
    const handleRouteChange = (location: any) => {
      if (window.localStorage.getItem('Authorization')) {
        const supportStr: any = localStorage.getItem('support')
        if (JSON.parse(supportStr)) {
          setWidgetShow(true)
        } else {
          setWidgetShow(false)
        }
      }
    }
    handleRouteChange(location)
  }, [location, widgetShowPropKey])

  useEffect(() => {
    const handleStorageChange = () => {
      // Check if the authentication data is missing (localStorage was cleared)
      if (!localStorage.getItem('Authorization')) {
        logout() // Call your logout logic
      }
    }

    // Add an event listener for changes in `localStorage`
    window.addEventListener('storage', handleStorageChange)

    // Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])
  useEffect(() => {
    window.addEventListener('message', getWidgetMsg)
    return () => {
      window.removeEventListener('message', getWidgetMsg)
    }
  }, [])

  const getWidgetMsg = (event: any) => {
    if (event.data && event.data.app === 'widget') {
      setWidgetToggle(event.data.widgetShow)
      setWidgetRoute(event.data.url)
    }
  }

  const widgetReload = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage('reload', '*')
    }
  }
  const widgetLogout = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage('logout', '*')
    }
  }
  const logout = async () => {
    // if (issuesProjectLength > 0) {
    if (isLoggingOutRef.current) return // If logout is already in progress, do nothing.
    isLoggingOutRef.current = true // Set to true to prevent subsequent logout calls
    try {
      // Call your logout API
      const data: any = await Apiservices.getUserLogout()
      removeAll()
      widgetLogout()
      cookies.remove('JWT-TOkEN')
      cookies.remove('JWT_TOKEN')
      cookies.remove('org_id')
      cookies.remove('torg_id')
      cookies.remove('profileView')
      cookies.remove('tool_name')
      cookies.remove('ecdb_user_id')

      cookies.remove('JWT-TOkEN', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('JWT_TOKEN', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('org_id', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('torg_id', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('profileView', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('tool_name', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('ecdb_user_id', {path: '/', domain: '.msrcosmos.com'})

      // Show toast error for session expired
      toast.error('Session expired', {
        position: toast.POSITION.BOTTOM_LEFT,
      })
      // Redirect after a delay
      setTimeout(() => {
        navigate('/login')
      }, 1000)

      // Ensure we reset the flag and cleanup after toast is shown
      setTimeout(() => {
        isLoggingOutRef.current = false // Reset logout flag after toast delay
      }, 1000)
    } catch (error) {
      console.error('Error during logout:', error)
    } finally {
      isLoggingOutRef.current = false // Reset logout flag
    }
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])
  // const getValidate = async () => {
  //   const res: any = await Apiservices.getValidate()
  //   if (!(res.data.statusCode == 200)) {
  //     issuesProjectLength += 1
  //     logout()
  //   }
  // }

  const getCookie = async (prm: any) => {
    let issuesProjectLength = 0
    if (prm == true || prm == false) {
      setWidgetShowPropKey(prm)
    }
    // const res: any = await Apiservices.getValidate()
    // if (res.data.statusCode == 200) {
    //   // cookies.set('JWT-TOkEN', res.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //   // cookies.set('JWT_TOKEN', res.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //   if (
    //     window.location.hostname === 'timesheets-uat.msrcosmos.com' ||
    //     window.location.hostname === 'timesheets.msrcosmos.com'
    //   ) {
    //     cookies.set('JWT-TOkEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //     cookies.set('JWT_TOKEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //   } else {
    //     cookies.set('JWT-TOkEN', res.data.accessToken)
    //     cookies.set('JWT_TOKEN', res.data.accessToken)
    //   }
    // }
    // if (!(res && res.data && res.data.statusCode == 200)) {
    //   if (issuesProjectLength == 0) {
    //     issuesProjectLength += 1
    //     logout()
    //   }
    //   // logout()
    // }
    let userId = parseInt(localStorage.getItem('ecdb_user_id') || '0', 10)
    const data123: any = await Apiservices.getChangePassword1(userId, {
      orgId: localStorage.getItem('org_id'),
      toolName: 'Timesheet Tracker',
    })
    if (data123.status == 200) {
      if (data123.data.passwordExpiryDays != localStorage.getItem('passwordExpiryDays')) {
        localStorage.setItem('passwordExpiryDays', data123.data.passwordExpiryDays)
        sessionStorage.setItem(
          'isPassKey',
          JSON.stringify(
            data123?.data?.passwordPopUpDays - data123?.data?.passAlert <=
              data123?.data?.passwordExpiryDays
              ? 'true'
              : 'false'
          )
        )
      }
    }
    if (
      (cookies.get('JWT-TOkEN') || cookies.get('JWT_TOKEN')) &&
      cookies.get('org_id') &&
      cookies.get('torg_id') == cookies.get('org_id')
    ) {
      const data1: any = await Apiservices.getSSO()
      if (data1 && data1.data && data1.data.statusCode == 200) {
        // cookies.set('JWT-TOkEN', data1.data.accessToken)
        // cookies.set('JWT_TOKEN', data1.data.accessToken)
        cookies.set('JWT-TOkEN', data1.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
        cookies.set('JWT_TOKEN', data1.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
      } else {
        logout()
      }
    } else if (
      (cookies.get('JWT-TOkEN') || cookies.get('JWT_TOKEN')) &&
      cookies.get('org_id') &&
      cookies.get('torg_id') != cookies.get('org_id')
    ) {
      navigate('OrganizationList')
    } else {
      const res: any = await Apiservices.getValidate()
      if (res.data.statusCode == 200) {
        if (
          window.location.hostname === 'timesheets-uat.msrcosmos.com' ||
          window.location.hostname === 'timesheets.msrcosmos.com'
        ) {
          cookies.set('JWT-TOkEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
          cookies.set('JWT_TOKEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
        } else {
          cookies.set('JWT-TOkEN', res.data.accessToken)
          cookies.set('JWT_TOKEN', res.data.accessToken)
        }
      } else if (!(res && res.data && res.data.statusCode == 200)) {
        logout()
      }
    }

    if (data123.status == 200 && prm == 'vyshu') {
      return data123.data
    }
  }
  const handleDownload = async (url1: string) => {
    try {
      const token = localStorage.getItem('Authorization') // or however you store your JWT
      if (!token) {
        console.error('No authentication token found')
        return
      }
      const response: any = await fetch(url1, {
        method: 'GET',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) {
        toast.warn(response.statusText)
        throw new Error(`Failed to download file: ${response.statusText}`)
      }
      // Get the filename from Content-Disposition header or use provided/default
      const contentDisposition = response.headers.get('Content-Disposition')
      let downloadFilename = 'Downloaded File'
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
        if (filenameMatch) {
          downloadFilename = filenameMatch[1]
        }
      }
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', downloadFilename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      // window.URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('Download failed:', error)
      // You can add toast notification or other error handling here
    }
  }

  // const handleViewToken = async (url1: string) => {
  //   console.log(url1, 'url1')
  //   try {
  //     const token = localStorage.getItem('Authorization') // or however you store your JWT
  //     if (!token) {
  //       console.error('No authentication token found')
  //       return
  //     }
  //     const response: any = await fetch(url1, {
  //       method: 'GET',
  //       headers: {
  //         Authorization: token,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     if (!response.ok) {
  //       toast.warn(response.statusText)
  //       throw new Error(`Failed to download file: ${response.statusText}`)
  //     }
  //     const blob = await response.blob()
  //     const url = window.URL.createObjectURL(blob)
  //     window.open(url, '_blank')
  //     // window.URL.revokeObjectURL(link.href)
  //   } catch (error) {
  //     console.error('Download failed:', error)
  //     // You can add toast notification or other error handling here
  //   }
  // }
  const getDemoBlob = async (doc: any): Promise<Blob | null> => {
    if (doc._blob) return doc._blob

    const fileName = doc.original_name?.toLowerCase()
    const extension = fileName ? fileName.split('.').pop() : undefined

    // ✅ Word documents
    if (extension === 'docx') {
      if (doc.blobUrl) {
        try {
          const token = localStorage.getItem('Authorization')

          if (!token) {
            return null
          }
          const response: any = await fetch(doc.blobUrl, {
            method: 'GET',
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          })
          if (!response.ok) {
            toast.warn(response.statusText)
            throw new Error(`Failed to fetch DOCX: ${response.statusText}`)
          }
          const blob = await response.blob()
          return blob
        } catch (error) {
          return null
        }
      }
    }
    if (extension === 'xlsx' || extension === 'xls') {
      if (doc.blobUrl) {
        try {
          const token = localStorage.getItem('Authorization')
          if (!token) {
            return null
          }
          const response: any = await fetch(doc.blobUrl, {
            method: 'GET',
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          })
          if (!response.ok) {
            toast.warn(response.statusText)
            throw new Error(`Failed to download file: ${response.statusText}`)
          }
          const blob = await response.blob()
          return blob
        } catch (error) {
          return null
        }
      }
      return null
    }
    return null
  }
  const handleViewToken = async (url1: string, single_obj?: any) => {
    setShowBackDrop(true)
    const fileName = single_obj?.original_name?.toLowerCase()
    const extension = fileName ? fileName.split('.').pop() : undefined
    // const blob = await getDemoBlob(single_obj)
    if (extension === 'docx') {
      const blob = await getDemoBlob(single_obj)
      if (blob) {
        try {
          const mammoth = await import('mammoth')
          const arrayBuffer = await blob.arrayBuffer()
          // ✅ ENHANCED CONVERSION WITH BETTER BORDER SUPPORT
          const result = await mammoth.convertToHtml(
            {
              arrayBuffer,
            },
            {
              styleMap: [
                "p[style-name='Heading 1'] => h1:fresh",
                "p[style-name='Heading 2'] => h2:fresh",
                "p[style-name='Heading 3'] => h3:fresh",
                "p[style-name='Heading 4'] => h4:fresh",
                "p[style-name='Title'] => h1.title:fresh",
                "p[style-name='Subtitle'] => p.subtitle:fresh",
                "p[style-name='Normal'] => p:fresh",
                "r[style-name='Strong'] => strong",
                "r[style-name='Emphasis'] => em",
              ],
              includeDefaultStyleMap: true,
              includeEmbeddedStyleMap: true,
              ignoreEmptyParagraphs: false,
              convertImage: mammoth.images.imgElement(function (image: any) {
                return image.read('base64').then(function (imageBuffer: string) {
                  return {
                    src: 'data:' + image.contentType + ';base64,' + imageBuffer,
                  }
                })
              }),
            }
          )

          // ✅ POST-PROCESS HTML TO ADD MISSING HORIZONTAL LINES
          let processedHtml = result.value

          // Add horizontal line after contact info section
          processedHtml = processedHtml.replace(
            /(Location:.*?<\/p>)/i,
            '$1<hr class="section-divider">'
          )

          // Add horizontal line after Professional Summary
          processedHtml = processedHtml.replace(
            /(healthcare\.<\/p>)/i,
            '$1<hr class="section-divider">'
          )

          // Add horizontal line after Core Competencies
          processedHtml = processedHtml.replace(
            /(Strong Presentation.*?<\/li>\s*<\/ul>)/i,
            '$1<hr class="section-divider">'
          )

          const htmlContent = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>${single_obj?.original_name || 'Document'}</title>
                <style>
                  * {
                    box-sizing: border-box;
                    margin: 0;
                    padding: 0;
                  }
                  
                  body {
                    font-family: 'Calibri', 'Aptos', 'Arial', sans-serif;
                    background-color: #525659;
                    padding: 40px 20px;
                    color: #000000;
                    line-height: 1.5;
                  }
                  
                  /* Page container */
                  .page {
                    max-width: 816px;
                    margin: 0 auto;
                    background: #ffffff;
                    padding: 96px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.3);
                    min-height: 1056px;
                  }
                  
                  /* Typography */
                  body, p, div {
                    font-size: 11pt;
                    line-height: 1.5;
                  }
                  
                  /* Name/Title at top */
                  h1:first-child,
                  p:first-child {
                    margin-top: 0;
                  }
                  
                  /* Headings */
                  h1, h2, h3, h4, h5, h6 {
                    font-weight: bold;
                    margin-top: 12pt;
                    margin-bottom: 6pt;
                    line-height: 1.3;
                  }
                  
                  h1 {
                    font-size: 16pt;
                    color: #000000;
                    text-transform: uppercase;
                    letter-spacing: 0.5pt;
                    margin-bottom: 4pt;
                  }
                  
                  h2 {
                    font-size: 14pt;
                    color: #000000;
                    text-transform: uppercase;
                    font-weight: bold;
                    margin-top: 16pt;
                    margin-bottom: 8pt;
                  }
                  
                  /* Paragraphs */
                  p {
                    margin-bottom: 4pt;
                    text-align: left;
                  }
                  
                  /* Text formatting */
                  strong, b {
                    font-weight: bold;
                  }
                  
                  em, i {
                    font-style: italic;
                  }
                  
                  /* Lists */
                  ul, ol {
                    margin-top: 0;
                    margin-bottom: 8pt;
                    padding-left: 24pt;
                  }
                  
                  li {
                    margin-bottom: 4pt;
                    line-height: 1.5;
                  }
                  
                  ul li {
                    list-style-type: disc;
                  }
                  
                  /* Links */
                  a {
                    color: #0563c1;
                    text-decoration: none;
                  }
                  
                  a:hover {
                    text-decoration: underline;
                  }
                  
                  /* ✅ HORIZONTAL LINES - CRITICAL FIX */
                  hr,
                  .section-divider {
                    border: none;
                    border-top: 1.5pt solid #000000;
                    margin: 12pt 0;
                    height: 0;
                    background: none;
                  }
                  
                  /* Handle paragraph borders as horizontal lines */
                  p[style*="border-bottom"],
                  p[style*="border-top"] {
                    border-bottom: 1.5pt solid #000000 !important;
                    padding-bottom: 6pt;
                    margin-bottom: 12pt;
                  }
                  
                  /* Tables */
                  table {
                    border-collapse: collapse;
                    width: 100%;
                    margin: 12pt 0;
                    font-size: 11pt;
                  }
                  
                  td, th {
                    border: 1px solid #000000;
                    padding: 4pt 6pt;
                    vertical-align: top;
                    text-align: left;
                  }
                  
                  th {
                    background-color: #4472c4;
                    color: #ffffff;
                    font-weight: bold;
                  }
                  
                  /* Images */
                  img {
                    max-width: 100%;
                    height: auto;
                    display: block;
                    margin: 12pt 0;
                  }
                  
                  /* Print support */
                  @media print {
                    body {
                      background: white;
                      padding: 0;
                    }
                    
                    .page {
                      box-shadow: none;
                      margin: 0;
                      max-width: none;
                    }
                  }
                </style>
              </head>
              <body>
                <div class="page">
                  ${processedHtml || '<p>No content found in document.</p>'}
                </div>
              </body>
            </html>
          `

          const htmlBlob = new Blob([htmlContent], {type: 'text/html'})
          const htmlUrl = window.URL.createObjectURL(htmlBlob)
          window.open(htmlUrl, '_blank')

          setTimeout(() => window.URL.revokeObjectURL(htmlUrl), 1000)
        } catch (err) {
          toast.error('Failed to preview document')
        }
      }
    } else if (extension === 'xlsx' || extension === 'xls') {
      const blob = await getDemoBlob(single_obj)
      if (blob) {
        try {
          const arrayBuffer = await blob.arrayBuffer()
          const XLSX = await import('xlsx')
          const workbook = XLSX.read(arrayBuffer, {type: 'array'})

          let sheetsHtml = ''

          workbook.SheetNames.forEach((sheetName, index) => {
            const sheet = workbook.Sheets[sheetName]
            const htmlTable = XLSX.utils.sheet_to_html(sheet, {
              header: '',
              footer: '',
            })

            sheetsHtml += `
              <div class="sheet-container">
                <h2 class="sheet-title">Sheet: ${sheetName}</h2>
                ${htmlTable}
              </div>
              ${index < workbook.SheetNames.length - 1 ? '<hr class="sheet-divider">' : ''}
            `
          })

          const htmlContent = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="UTF-8">
                <title>${single_obj?.original_name || 'Spreadsheet'}</title>
                <style>
                  body {
                    font-family: Onest, Arial, sans-serif;
                    margin: 20px;
                    padding: 20px;
                    background-color: #f5f5f5;
                  }
                  .sheet-container {
                    background: white;
                    padding: 20px;
                    margin-bottom: 20px;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    overflow-x: auto;
                  }
                  .sheet-title {
                    color: #333;
                    margin-top: 0;
                    margin-bottom: 15px;
                    font-size: 18px;
                    font-weight: 600;
                  }
                  .sheet-divider {
                    border: none;
                    height: 2px;
                    background: #e0e0e0;
                    margin: 30px 0;
                  }
                  table {
                    border-collapse: collapse;
                    width: 100%;
                    font-size: 14px;
                  }
                  td, th {
                    border: 1px solid #ddd;
                    padding: 8px 12px;
                    text-align: left;
                  }
                  th {
                    background-color: #f8f9fa;
                    font-weight: 600;
                    color: #333;
                  }
                  tr:nth-child(even) {
                    background-color: #f9f9f9;
                  }
                  tr:hover {
                    background-color: #f0f0f0;
                  }
                </style>
              </head>
              <body>
                <h1 style="color: #333; margin-bottom: 30px;">
                  ${single_obj?.original_name || 'Spreadsheet Preview'}
                </h1>
                ${sheetsHtml}
              </body>
            </html>
          `

          const htmlBlob = new Blob([htmlContent], {type: 'text/html'})
          const htmlUrl = window.URL.createObjectURL(htmlBlob)
          window.open(htmlUrl, '_blank')

          setTimeout(() => window.URL.revokeObjectURL(htmlUrl), 1000)
        } catch (err) {
          toast.error('Failed to preview spreadsheet')
        }
      }
    } else {
      try {
        const token = localStorage.getItem('Authorization')
        if (!token) {
          toast.error('Authentication required')
          return
        }
        const response = await fetch(url1, {
          method: 'GET',
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        })
        if (!response.ok) {
          toast.warn(response.statusText)
          throw new Error(`Failed to download file: ${response.statusText}`)
        }
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
        setTimeout(() => window.URL.revokeObjectURL(url), 1000)
      } catch (error) {
        toast.error('Failed to open document')
      }
    }
    setShowBackDrop(false)
  }

  const getValidate = (url: any, state1: any, single_object?: any) => {
    if (state1 == 'view') {
      handleViewToken(url, single_object)
    } else if (state1 == 'download') {
      handleDownload(url)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])
  const forcePasswordPopClose = () => {
    setresetPassword(false)
    sessionStorage.setItem('isPassKey', 'false')
  }
  let role = localStorage.getItem('role_Name')?.split(',').includes('admin')

  return (
    <ValidProvider value={{getValidate: getValidate}}>
      <ThingsProvider value={{getCookie: getCookie}}>
        <BackDrop showBackDrop={showBackDrop} />
        <PageDataProvider>
          <ThemeModeProvider>
            <div className='page d-flex flex-row flex-column-fluid'>
              <AsideDefault />
              <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                <HeaderWrapper widgetReload={widgetReload} widgetLogout={widgetLogout} />

                <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                  <Toolbar />
                  <div className='post d-flex flex-column-fluid' id='kt_post'>
                    <Content>
                      <Outlet />
                    </Content>
                  </div>
                </div>
                {/* {numArray?.includes('employee') && <Footer />} */}
                {widgetShow && (
                  <div
                    id='widget'
                    style={{
                      position: 'fixed',
                      right: '0',
                      bottom: '0',
                      zIndex: 9999,
                      width: widgetToggle ? '80vh' : '40px',
                      height: widgetToggle
                        ? ['/', '/intro'].includes(widgetRoute)
                          ? '580px'
                          : '750px'
                        : '40px',
                    }}
                  >
                    <iframe
                      ref={iframeRef}
                      src={iframeSrc}
                      title='widget'
                      style={{width: '100%', height: '100%', border: 'none'}}
                      allow='display-capture'
                    ></iframe>
                  </div>
                )}
                {resetPassword && <ResetPassword forcePasswordPopClose={forcePasswordPopClose} />}
              </div>
            </div>
            <div>{role && <ChatBotIcon />}</div>

            {/* begin:: Drawers */}
            <ActivityDrawer />
            <RightToolbar />
            <DrawerMessenger />
            {/* end:: Drawers */}

            {/* begin:: Modals */}
            <InviteUsers />
            <UpgradePlan />
            {/* end:: Modals */}
            <ScrollTop />
          </ThemeModeProvider>
        </PageDataProvider>
      </ThingsProvider>
    </ValidProvider>
  )
}

// export {MasterLayout}
